import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import apiClient from '../../../api/apiClient';

interface ApplicationReportProps {
  applicationId: string;
}

const ApplicationReport: React.FC<ApplicationReportProps> = ({
  applicationId,
}) => {
  const [iframeUrl, setIframeUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  //applicationId = '347579';
  useEffect(() => {
    if (!applicationId) return;

    setLoading(true);
    apiClient
      .get(
        `/v2/publisher/dashboard/application/metabase?application_id=${applicationId}`,
      )
      .then((res) => {
        if (res.data.iframeUrl) {
          setIframeUrl(res.data.iframeUrl);
        } else {
          throw new Error('iframeUrl not found in response');
        }
      })
      .catch((err) => {
        setError(err.message || 'Error fetching data');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [applicationId]);

  return (
    // A flex column filling the card: the iframe used to be a fixed 400px
    // inside a taller container, which left a band of empty white beneath it.
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: '12px',
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        component="div"
        sx={{
          textAlign: 'right',
          flexShrink: 0,
          fontFamily: 'IRANYekanXFaNum',
          fontSize: 16,
          fontWeight: 400,
          color: '#60646E',
        }}
      >
        گزارش دانلود
      </Typography>

      {loading && <CircularProgress />}
      {error && <Typography color="error">{error}</Typography>}

      {iframeUrl && (
        <iframe
          src={iframeUrl}
          title="گزارش اپ"
          style={{
            border: 'none',
            width: '100%',
            // Grows into whatever the card leaves, with a floor so the charts
            // stay readable in a short viewport.
            flex: 1,
            minHeight: '400px',
          }}
        ></iframe>
      )}
    </Box>
  );
};

export default ApplicationReport;
